import { createSelector } from '@reduxjs/toolkit'
import { AppState } from 'store/appState'

export const getAIAgentReportMessage = createSelector(
  (state: AppState) => state.ai.reportMessage,
  reportMessage => reportMessage,
)
